import { Injectable } from "@angular/core";
import { Logger } from "../../logger";
import { AutopilotRule } from "../../../domain/rule";
import moment, {Moment} from 'moment';

function toRule(rule: any) {
  return new AutopilotRule(
    rule.rule_uid,
    rule.rule_name,
    rule.rule_color,
    rule.is_active,
  );
}

function toAutopilotRule(response: any): AutopilotRule {
  let timeBasedTimeInterval,
    videoBasedDisplayOn,
    videoBasedFilterTags = "",
    videoBasedFilterCondition,
    videoBasedTimingType,
    videoBasedTimingInterval,
    alwaysBasedShowDuring,
    planRuleStartDate,
    planRuleStartTime,
    planRuleEndDate,
    planRuleEndTime,
    videoBasedTimingMinSec,
    videoBasedFitToWholeVideo;

  const recurringTimeBased = response.recurring_params.time_based_params;
  const recurringVideoBased = response.recurring_params.video_based_params;
  const recurringAlways = response.recurring_params.always_based_params;
  let videoBasedTimingMediaDurationMs = null;

  let timeBasedStartTimeMs = 0;
  let timeBasedEndTimeMs = 86400000;
  let timeBasedGraphicDurationMs = 3600000;

  if (recurringTimeBased) {
    timeBasedTimeInterval = recurringTimeBased.time_interval;
    timeBasedStartTimeMs = recurringTimeBased.time_start_offset_ms;
    timeBasedEndTimeMs = recurringTimeBased.time_end_offset_ms;
    timeBasedGraphicDurationMs = recurringTimeBased.graphic_duration_ms;
  }

  if (recurringVideoBased) {
    videoBasedDisplayOn = recurringVideoBased.display_on;
    if (recurringVideoBased.display_on_filter) {
      videoBasedFilterTags = recurringVideoBased.display_on_filter.tags;
      videoBasedFilterCondition =
        recurringVideoBased.display_on_filter.BasedVideoFilterCondition;
    }

    if (recurringVideoBased.appearance) {
      if (recurringVideoBased.appearance.appearance_fit_whole_video) {
        videoBasedFitToWholeVideo = true;
      } else {
        videoBasedTimingType = recurringVideoBased.appearance.timing_type;
        videoBasedTimingInterval =
          recurringVideoBased.appearance.timing_interval;
        videoBasedTimingMinSec =
          recurringVideoBased.appearance.timing_interval_min_sec;
        videoBasedTimingMediaDurationMs =
          recurringVideoBased.appearance.video_based_timing_media_duration_ms;
      }
    }
  } else if (recurringTimeBased) {
    timeBasedTimeInterval = recurringTimeBased.time_interval;
  }

  if (recurringAlways) {
    alwaysBasedShowDuring = recurringAlways.show_during;
  }

  const planRuleParams = response.plan_rule.limit_rule_params;
  if (planRuleParams) {
    planRuleStartDate = planRuleParams.start_date
      ? moment(moment.utc(planRuleParams.start_date).valueOf())
      : null;
    planRuleEndDate = planRuleParams.start_date
      ? moment(moment.utc(planRuleParams.end_date).valueOf())
      : null;

    /*planRuleStartTime = planRuleStartDate ? planRuleStartDate.clone() : null;
        planRuleEndTime = planRuleEndDate ? planRuleEndDate.clone() : null;*/
    console.log("planRuleParams", planRuleParams.start_date);
    console.log("planRuleParams", planRuleStartDate);
    planRuleStartTime = planRuleStartDate ? planRuleStartDate : null;
    planRuleEndTime = planRuleEndDate ? planRuleEndDate : null;
  }
  const segmentationBehaviour = response.segmentation_behavior;
  const rule = new AutopilotRule(
    response.rule_uid,
    response.rule_name,
    response.rule_color,
    response.is_active,
    response.recurring_type,
    timeBasedTimeInterval,
    timeBasedStartTimeMs,
    timeBasedEndTimeMs,
    timeBasedGraphicDurationMs,
    videoBasedDisplayOn,
    videoBasedFilterTags ? videoBasedFilterTags.split(",") : [],
    videoBasedTimingType,
    videoBasedTimingMediaDurationMs,
    videoBasedFilterCondition,
    videoBasedTimingInterval,
    alwaysBasedShowDuring,
    response.plan_rule.limit_rule,
    planRuleStartDate,
    planRuleEndDate,
    planRuleStartTime,
    planRuleEndTime,
    response.graphic_id,
    response.floating_media_id,
    videoBasedTimingMinSec,
    videoBasedFitToWholeVideo,
    segmentationBehaviour,
  );
  return rule;
}

@Injectable()
export class AutopilotMapper {
  constructor(private logger: Logger) {}

  mapGetGraphicsRuleResponse(response: any): Promise<AutopilotRule> {
    return Promise.resolve(toAutopilotRule(response));
  }

  mapGetAllAutopilotRulesResponse(response: any): Promise<AutopilotRule[]> {
    const rules = response.map((x: any) => toRule(x));
    return Promise.resolve(rules);
  }

  mapCreateOrUpdateRuleRequest(rule: AutopilotRule, channelId: number) {
    console.log("mapCreateOrUpdateRuleRequest", rule);
    let planLimitStartDate: string = null;
    let planLimitStartTime: string = null;
    let limitStartMoment: moment.Moment = null;
    if (rule.limitRuleStartDate && rule.limitRuleStartTime) {
      let ruleStartDateTemp = rule.limitRuleStartDate.clone();
      if (ruleStartDateTemp.tz() !== 'UTC') {
        ruleStartDateTemp = rule.limitRuleStartTime.clone();
        ruleStartDateTemp.utc();
        ruleStartDateTemp.tz('UTC', true).local();
        limitStartMoment = ruleStartDateTemp;
      } else {
        const limitStartMomentTemp = ruleStartDateTemp.clone().add(rule.limitRuleStartTime.hour(), 'hours').add(rule.limitRuleStartTime.minute(), 'minutes');
        limitStartMoment = moment(limitStartMomentTemp.format("YYYY-MM-DD HH:mm:ss"));
      }
      limitStartMoment.tz(rule.limitRuleStartTime.tz());
      planLimitStartDate = limitStartMoment.utc().format("YYYYMMDD");
      planLimitStartTime = limitStartMoment.utc().format("HHmmss");
    }

    let planLimitEndDate: string = null;
    let planLimitEndTime: string = null;
    let limitEndMoment: moment.Moment = null;
    if (rule.limitRuleEndDate && rule.limitRuleEndTime) {
      let ruleEndDateTemp = rule.limitRuleEndDate.clone();
      if (ruleEndDateTemp.tz() !== 'UTC') {
        ruleEndDateTemp = rule.limitRuleEndTime.clone();
        ruleEndDateTemp.utc();
        ruleEndDateTemp.tz('UTC', true).local();
        limitEndMoment = ruleEndDateTemp;
      } else {
        const limitEndMomentTemp = ruleEndDateTemp.clone().add(rule.limitRuleEndTime.hour(), 'hours').add(rule.limitRuleEndTime.minute(), 'minutes');
        limitEndMoment = moment(limitEndMomentTemp.format("YYYY-MM-DD HH:mm:ss"));
      }
      limitEndMoment.tz(rule.limitRuleEndTime.tz());
      planLimitEndDate = limitEndMoment.utc().format("YYYYMMDD");
      planLimitEndTime = limitEndMoment.utc().format("HHmmss");
    }

    return {
      RuleId: rule.id,
      ChannelId: channelId,
      RuleName: rule.name,
      RuleColor: rule.color,
      GraphicId: rule.graphicId || undefined,
      FloatingMediaId: rule.floatingMediaId || undefined,
      RecurringType: rule.recurringType,
      BasedTimeInterval: rule.timeBasedIntervalMins,
      BasedVideoDisplayOn: rule.videoBasedDisplayOn,
      BasedVideoFilterTags: rule.videoBasedFilterTags.join(","),
      BasedVideoFilterCondition: rule.videoBasedFilterCondition,
      BasedVideoTimingInterval: rule.videoBasedTimingInterval,
      BasedVideoTimingType: rule.videoBasedTiming,
      BasedAlwaysShowDuring: rule.alwaysBasedDuring,
      PlanLimitRule: rule.limitRule,
      PlanLimitStartDate: planLimitStartDate,
      PlanLimitEndDate: planLimitEndDate,
      PlanLimitStartTime: planLimitStartTime,
      PlanLimitEndTime: planLimitEndTime,
      VideoBasedTimingMinSec: rule.videoBasedTimingMinSec,
      BasedVideoFitGraphicToWholeVideo: rule.videoBasedFitToWholeVideo,
      TimeStartOffsetMs: rule.timeBasedTimeStartMs,
      TimeEndOffsetMs: rule.timeBasedTimeEndMs,
      GraphicDurationMs: rule.timeBasedGraphicDurationMs,
      SegmentationBehavior: rule.segmentationBehaviour,
      BasedVideoTimingMediaDurationMs: rule.videoBasedTimingVideoDurationMs,
    };
  }
}
